export const formatPHP = (n) => new Intl.NumberFormat('en-PH', { minimumFractionDigits: 2 }).format(n || 0);

export const formatDatePH = (d) => (d ? new Date(d).toLocaleDateString('en-PH') : '—');
